import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LetDirective } from '@ngrx/component';

import { BrandLinkComponent } from 'src/app/shared/brand-link/brand-link.component';

import { DealerLocatorComponent } from '../dealer-locator/dealer-locator.component';

import { HeaderComponent } from './header.component';

@NgModule({
  imports: [CommonModule, DealerLocatorComponent, LetDirective, HeaderComponent, BrandLinkComponent],
  exports: [HeaderComponent]
})
export class HeaderModule {}
